import { p as promiseResolve, b as bootstrapLazy } from './index-6edd38ce.js';

/*
 Stencil Client Patch Esm v2.17.1 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
    return promiseResolve();
};

const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
  return bootstrapLazy([["eqpodc-save-button",[[1,"eqpodc-save-button",{"commissionNumber":[1025,"commission-number"],"productCode":[1025,"product-code"],"vehicleId":[1025,"vehicle-id"],"vehicleOnlineCode":[1025,"vehicle-online-code"],"clientId":[1025,"client-id"],"isDisabled":[4,"is-disabled"],"saveOnly":[4,"save-only"],"uiType":[1,"ui-type"],"saveLabel":[1,"save-label"],"savedLabel":[1,"saved-label"],"size":[1],"color":[1],"owcComponentId":[1,"component-id"],"isSaved":[32],"isLoading":[32],"isEnabled":[32],"isDisplayed":[32],"locale":[32],"environment":[32]}]]]], options);
  });
};

export { defineCustomElements };
